import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Ad from '@ifeng/ui_pc_ad';
import { getHotSale } from '../../../../../../services/api';
import { rel } from '../../../../../../utils/rel';
import EnqueryAlert from '../../../../components/enqueryAlert';

class HotSale extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            // 返回当前标签的数据\
            showAllData: {},
            showData: [],
            // 类型选择状态
            selectLevel: 1,
            isEnqueryAlertShow: false,
            carSeriesData: {},
        };
    }
    static propTypes = {
        curCity: PropTypes.object,
    };

    async componentDidMount() {
        try {
            const showData = await getHotSale(new Date().getFullYear(), new Date().getMonth(), '');
            const showAllData = Object.assign(this.state.showAllData, { type1: showData });

            this.setState({
                showAllData,
                showData,
            });
        } catch (error) {
            console.log(error);
        }
    }
    async handleLevel(id, param) {
        const selectLevel = id;

        if (this.state.showAllData[`type${id}`]) {
            this.setState({
                showData: this.state.showAllData[`type${id}`],
                selectLevel,
            });
        } else {
            try {
                const showData = await getHotSale(new Date().getFullYear(), new Date().getMonth(), param);

                const showAllData = Object.assign(this.state.showAllData, { [`type${id}`]: showData });

                this.setState({
                    showData,
                    showAllData,
                });
            } catch (error) {
                console.log(error);
            }
            this.setState({
                selectLevel,
            });
        }
    }
    getChildData = res => {
        this.setState({
            isEnqueryAlertShow: res,
        });
    };
    xunjiaHandlerClick = item => {
        const carSeriesData = {
            brand: item.brandId,
            serial: item.serialid,
        };

        this.setState({
            carSeriesData: Object.assign({}, carSeriesData),
            isEnqueryAlertShow: true,
        });
    };
    ViewHotSale(_data) {
        const displayHotSale = level => {
            let levelArr = [
                ['全部', ''],
                ['微型车', 1],
                ['小型车', 2],
                ['紧凑型车', 3],
                ['中型车', 5],
                ['中大型车', 4],
                ['SUV', 8],
                ['MPV', 7],
            ];
            let m = [];

            for (let i = 0; i < levelArr.length; i++) {
                let x = i + 1;

                m.push(
                    <li
                        key={i}
                        className={x === level ? styles.on : styles.off}
                        onMouseEnter={() => this.handleLevel(x, levelArr[i][1])}>
                        {levelArr[i][0]}
                    </li>,
                );
            }

            return m;
        };

        const displayCar = list => {
            const carList = [];

            if (list && list.saleslist.length > 0) {
                let firstArr = list.saleslist.slice(0, 1)[0];

                carList.push(
                    <ul key="showcar_ul" className={styles.showcar_ul}>
                        <li className={styles.showcar_ul_li_first} key="first">
                            <div className={styles.showcar_div}>
                                <div className={styles.showcar_index}>1</div>
                                <div className={styles.showcar_imgdiv}>
                                    <a
                                        target="_blank"
                                        href={`//car.auto.ifeng.com/series/${firstArr.serialid}`}
                                        rel={rel}>
                                        <img src={firstArr.seriallogo} width="90" height="60" />
                                    </a>
                                </div>
                                <a
                                    target="_blank"
                                    href={`//car.auto.ifeng.com/series/${firstArr.serialid}`}
                                    rel={rel}
                                    className={styles.showcar_plist}>
                                    <p className={styles.name_li}>
                                        <span>{firstArr.serialname}</span>
                                    </p>
                                    <p className={styles.info_li}>
                                        <span>月销：{firstArr.amount}台</span>
                                    </p>
                                </a>

                                <ul className={styles.showcar_plist_first_child}>
                                    <li className={styles.info_li_ask}>
                                        <a
                                            href="javascript:void(0);"
                                            onClick={this.xunjiaHandlerClick.bind(this, firstArr)}>
                                            询底价
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </li>
                        {list.saleslist.slice(1, list.saleslist.length).map((item, index) => (
                            <ul className={styles.list_ul} key={`ul${index}`}>
                                <div className={styles.showcar_index}>{index + 2}</div>
                                <a
                                    target="_blank"
                                    href={`//car.auto.ifeng.com/series/${item.serialid}`}
                                    rel={rel}
                                    className={styles.showcar_plist}>
                                    <p className={styles.name_li}>
                                        <span>{item.serialname}</span>
                                    </p>
                                    <p className={styles.info_li}>
                                        <span>月销：{item.amount}台</span>
                                    </p>
                                </a>
                                <ul className={styles.showcar_ask}>
                                    <li className={styles.info_li_ask}>
                                        <a
                                            href="javascript:void(0);"
                                            onClick={this.xunjiaHandlerClick.bind(this, item)}>
                                            询底价
                                        </a>
                                    </li>
                                </ul>
                            </ul>
                        ))}
                    </ul>,
                );
            } else {
                carList.push(<h2 key="nullCar">搜索条件没有相关数据</h2>);
            }

            return carList;
        };

        return (
            <div>
                <div className={styles.hotsale_div}>
                    <ul className={styles.tab_ul}>{displayHotSale(this.state.selectLevel)}</ul>
                </div>
                <div className={styles.car_div}>{displayCar(_data.data)}</div>
                {this.state.isEnqueryAlertShow ? (
                    <EnqueryAlert news={this} carSeriesData={this.state.carSeriesData} curCity={this.props.curCity} />
                ) : (
                    ''
                )}
            </div>
        );
    }

    /**
     * 渲染组件
     */
    render() {
        return <div>{this.ViewHotSale(this.state.showData)}</div>;
    }
}

export default HotSale;
